import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth/auth.service';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

/**
 * Error Interceptor (Functional Interceptor)
 *
 * Handles HTTP error responses globally:
 * - 401 Unauthorized: User session expired or invalid → redirect to sign-in
 * - 403 Forbidden: User lacks permissions → redirect to unauthorized page
 *
 * Other errors are re-thrown for component-level handling.
 *
 * Registration in app.config.ts:
 * ```typescript
 * provideHttpClient(
 *   withInterceptors([jwtInterceptor, errorInterceptor])
 * )
 * ```
 */
export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  const authService = inject(AuthService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401) {
        // 401 Unauthorized - session expired or invalid
        console.error('401 Unauthorized - redirecting to sign-in');
        authService.federatedSignIn();
      } else if (error.status === 403) {
        // 403 Forbidden - user lacks required permissions
        console.error('403 Forbidden - redirecting to unauthorized page');
        router.navigate(['/unauthorized']);
      }

      // Re-throw error for component-level handling
      return throwError(() => error);
    })
  );
};
